exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".A3haayjq-17R4-tF1Elz2{position:absolute;width:0;height:0;opacity:0}", ""]);

// exports
exports.locals = {
	"button": "A3haayjq-17R4-tF1Elz2"
};